export const REQUEST_MANAGER_OPENED_CLAIMS: string =
  'REQUEST_MANAGER_OPENED_CLAIMS';
export const SET_MANAGER_OPENED_CLAIMS: string = 'SET_MANAGER_OPENED_CLAIMS';

export const REQUEST_SAGIS_LAWYER_ASSIGNED_CLAIMS =
  'REQUEST_SAGIS_LAWYER_ASSIGNED_CLAIMS';

export const SET_SAGIS_LAWYER_ASSIGNED_CLAIMS =
  'SET_SAGIS_LAWYER_ASSIGNED_CLAIMS';
